import { render } from "./Calleds.vue?vue&type=template&id=4cea6068&scoped=true"
import script from "./Calleds.vue?vue&type=script&lang=js"
export * from "./Calleds.vue?vue&type=script&lang=js"

import "./Calleds.vue?vue&type=style&index=0&id=4cea6068&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cea6068"]])

export default __exports__